import React from 'react'
import styles from "./commonQuestions.module.scss";
import HoverTile from '../hoverTile/HoverTile';

const CommonQuestions = ({questioData}) => {
  return (
    <div className={styles.container}>
        <div className={styles.wrapper}>
            <div className={styles.top}>
                <div className={styles.title}>Answers for</div>
                <div className={styles.subTitle}>common questions</div>
            </div>
            <div className={styles.bottom}>
                <HoverTile hoverData = {questioData}/>
            </div>
        </div>
    </div>
  )
}

export default CommonQuestions